<template>
  <component :is="currentComponent" :class="isEmbed && 'embedWrap'" v-model="visible" @close="close">
    <div class="point-read" :class="isEmbed && 'embed'" @click.stop v-if="visible">
      <!-- <div class="word-row" :class="['word-row-'+ styleType]">
        <div class="word-item" v-for="(w,i) in row.words" :key="i">
          <div class="mark" v-if="w.markIsLeft && w.mark">{{w.mark}}</div>
          <div class="word">
            <div class="piny" :class="{'align-right': w.isRight && styleType == 2 && index > 0, 'align-left': w.isLeft && styleType == 2  && index > 0}" v-if="w.py" v-text="w.py"></div>
            <div class="zh" v-text="w.zh"></div>
          </div>
          <div class="mark" v-if="w.markIsRight && w.mark">{{w.mark}}</div>
        </div>
      </div> -->
      <div class="book-words" :class="['book-words-'+ styleType]">
        <div class="word-row">
          <WordRow :row="row" />
        </div>
      </div>
      <div class="btn-box">
        <div class="play-btns">
          <button class="btn btn-pre" :class="{'disabled': row.preDisabled}" @click.stop="playType(1)"></button>
          <button class="btn btn-play" @click.stop="playType(3)">
            <i class="icon icon-play" :class="{'icon-pause': row.isPlay}"></i>
          </button>
          <button class="btn btn-next" :class="{'disabled': row.nextDisabled}" @click.stop="playType(2)"></button>
        </div>
      </div>
    </div>
  </component>
</template>
<script>
import VMask from 'base/mask'
import WordRow from 'business/WordRow';

export default {
  components: {
    VMask: VMask,
    WordRow
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    styleType: {
      type: Number,
      default: 0
    },
    // 是否为嵌入
    isEmbed: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object,
      default () {
        return {
          words: [],
          preDisabled: false,
          nextDisabled: false,
          isPlay: false
        }
      }
    }
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal != oldVal) {
        this.visible = newVal;
        if(newVal) {
          this.$store.commit("setKnowledgeSettings", {
              ...this.getKnowledgeSettings,
              isOpen: false,
            });
        }
      }
    }
  },
  data() {
    return {
      visible: this.value,
      currentComponent: this.isEmbed ? 'div' : VMask
    }
  },
  methods: {
    close() {
      this.visible = false;
      this.$emit('input', false);
      this.$emit('close', false);
    },
    playType(type) {
      this.$emit('onChange', type);
    }
  }
}

</script>
<style lang="less" scoped>
.embedWrap {
  height: 100%;
  flex: 1;
  overflow: hidden;
}
.point-read {
  max-height: 82vh;
  padding: 30px 0 35px;
  width: 650px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  &:not(.embed) {
    position: fixed;
    z-index: 2000;
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: 27px;
    left: 50%;
    top: 50%;
  }
  &.embed {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    padding: 5% 0 0;
    .book-words {
      margin: initial;
      &::-webkit-scrollbar {
        width: 0;
        height: 0;
        background: transparent;
      }
    }
    .btn-box {
      padding-top: 24px;
      box-sizing: border-box;
      height: 120px;
      background: #FFFFFF;
      box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);
    }
    .word-row {
      display: inline-block;
      transform: scale(1.4);
      transform-origin: left top;
      white-space: normal;
      width: 71%;
      margin: 0 auto;
    }
  }
  .book-words {
    padding-bottom: 0;
    overflow: auto;
    flex-shrink: initial;
  }
}
.btn-box {
  padding-top: 18px;
}
</style>
